import { Controller } from "@hotwired/stimulus"

// Passerelle entre le bouton « fiche officielle » d'un indicateur et le modal
// de preview PDF partagé du dashboard. Avant l'ouverture du modal (action
// `modal#open` chaînée sur le même clic), pose l'URL de la fiche (PDF #page=N)
// sur le modal ; le pdf-preview controller rechargera cette page à l'ouverture.
export default class extends Controller {
  static values = { url: String, modalId: String }

  openFiche() {
    // Charge la fiche de l'indicateur à sa page, de façon déterministe (avant
    // l'ouverture du modal déclenchée par l'action modal#open chaînée).
    const modal = document.getElementById(this.modalIdValue)
    const preview = modal && this.application.getControllerForElementAndIdentifier(modal, "pdf-preview")
    if (preview) preview.reloadWith(this.urlValue)

    // Masque le popover de l'indicateur pour qu'il ne reste pas derrière le modal.
    const popover = this.element.closest("[popover]")
    if (popover?.matches(":popover-open")) popover.hidePopover()
  }
}
